import React from 'react';
import { X } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

function trendColor(diff, direction) {
  if (diff == null || diff === 0 || direction === 'neutral') return 'var(--text-dimmed)';
  const improved = direction === 'higher' ? diff > 0 : diff < 0;
  return improved ? '#10b981' : '#ef4444';
}

export default function PlayerStatTrendModal({ title, unit = '', data, current, previous, trendDirection = 'neutral', color = '#f59e0b', onClose }) {
  const diff = (current != null && previous != null) ? Number(current) - Number(previous) : null;

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 20 }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, width: '100%', maxWidth: 420, padding: 20, boxShadow: '0 40px 80px rgba(0,0,0,0.6)' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 4 }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>{title}</h2>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', padding: 4 }}>
            <X size={18} />
          </button>
        </div>

        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, margin: '8px 0 16px' }}>
          <div style={{ fontSize: 26, fontWeight: 700 }}>
            {current != null ? `${Number(current).toFixed(1)}${unit}` : '—'}
          </div>
          {diff != null && (
            <div style={{ fontSize: 13, fontWeight: 700, color: trendColor(diff, trendDirection) }}>
              {diff > 0 ? '▲' : diff < 0 ? '▼' : '–'} {Math.abs(diff).toFixed(1)}{unit} vs previous
            </div>
          )}
        </div>

        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={data}>
              <XAxis dataKey="date" stroke="var(--text-dimmed)" tick={{ fill: 'var(--text-secondary)', fontSize: 10 }} />
              <YAxis stroke="var(--text-dimmed)" tick={{ fill: 'var(--text-secondary)', fontSize: 10 }} domain={['auto', 'auto']} />
              <Tooltip contentStyle={{ background: 'var(--border)', border: '1px solid var(--border-strong)', borderRadius: 8, fontSize: 12 }} formatter={v => `${Number(v).toFixed(1)}${unit}`} />
              <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={{ r: 3 }} connectNulls />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div style={{ height: 220, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-dimmed)', fontSize: 12 }}>No data yet</div>
        )}
      </div>
    </div>
  );
}
